import { get_gallery_info } from "@/utils/get_gallery_info";
import { nanoid } from "nanoid";
declare global {
  interface Window {
    yaContextCb: Array<() => void>;
    Ya: {
      adfoxCode: {
        create: (config: {
          ownerId: string;
          containerId: string;
          type?: string | undefined;
          platform?: string | undefined;
          params: Record<string, string>;
          lazyLoad?: { mobileScaling?: number | undefined; fetchMargin?: number | undefined } | undefined;
        }) => void;
      };
    };
  }
}

interface Dex3Props {
  type?: string;
  ownerId: string;
  containerId: string;
  p1: string;
  p2: string;
  google_aid?: string;
  platform?: string;
  lazyLoad?: {
    mobileScaling?: number;
    fetchMargin?: number;
  };
}
export default function Dex3(props: Dex3Props) {
  const {
    type = "dex",
    platform,
    ownerId,
    containerId,
    p1,
    p2,
    google_aid = get_gallery_info(),
    lazyLoad = {},
  } = props;
  const [isMounted, setIsMounted] = useState(false);
  const [containerId1, setContainerId1] = useState("");
  useEffect(() => {
    setIsMounted(true);
    setContainerId1(containerId + "_" + nanoid(3));
    return () => {
      setIsMounted(false);
    };
  }, []);
  useEffect(() => {
    if (!isMounted || !document.getElementById(containerId1)) return;
    window.yaContextCb = window.yaContextCb || [];
    window.yaContextCb.push(() => {
      window.Ya.adfoxCode.create({
        ownerId,
        containerId: containerId1,
        ...(type === "floorAd" && { type, platform }),
        ...(type === "dex" && { lazyLoad }),
        params: {
          p1,
          p2,
          google_aid,
        },
      });
    });
  }, [isMounted, containerId1]);
  return <div id={containerId1}></div>;
}
